import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import { connect } from 'react-redux';
import { mixtureSubstancesBySubstance, needsScenarioByShipment, shipmentsBySubstance } from 'selectors/generic';
import theme from 'source/theme';
import { SCENARIO_EP } from 'utils/constants/coreConstants';
import { lcsExternalExposure } from 'utils/constants/lcsTypes';

const columns = [
  { title: 'Código MP', field: 'raw_material_code' },
  { title: 'Matéria prima', field: 'raw_material_name' },
  { title: 'Fornecimento', field: 'code' },
  { title: 'Desig. Comercial', field: 'trade_name' },
  { title: 'Fornecedor', field: 'name' }
];


const Component = props => {

  const {
    mixturesOfSubstance, needsScenarioOf, rowData, dataById, shipmentsOfSubstance,
    suppliersById, title, extra
  } = props;
  const { scenarios, shipmentsById } = extra;

  let filteredScenarios = scenarios.filter(s =>
    s.type === SCENARIO_EP &&
    s.raw_material_supplier_id &&
    lcsExternalExposure.includes(parseInt(s.lcs_id)) &&
    (
      rowData.id === shipmentsById[s.raw_material_supplier_id].raw_material_id ||
      (mixturesOfSubstance[rowData.id] || [])
        .map(mix => mix.mixture_id)
        .includes(shipmentsById[s.raw_material_supplier_id].raw_material_id)
    )
  );

  filteredScenarios = filteredScenarios.map( scenario => scenario.raw_material_supplier_id);

  const rows = [];
  const augmentedRow = (primaryRow, secondaryRow) => ({
    ...primaryRow,
    raw_material_name: secondaryRow.name,
    raw_material_code: secondaryRow.code,
    name: suppliersById[primaryRow.supplier_id].name,
    backgroundColor: !filteredScenarios.includes(primaryRow.id) ?
      theme.palette.error.light : null
  });

  // The substance's own shipments, then those of every mixture it is part of,
  // in that order - two loops over `raw_material_suppliers` before, one index
  // now. The raw material of the shipment is the row itself when it is direct.
  (shipmentsOfSubstance[rowData.id] || []).forEach(({ rawMaterialId, shipment }) => {
    if (needsScenarioOf[shipment.id]) {
      rows.push(augmentedRow(
        shipment,
        rawMaterialId === rowData.id ? rowData : dataById[rawMaterialId]
      ));
    }
  });

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable title={title} columns={columns} rows={rows}/>
    </div>
  );
};

const mapStateToProps = state => ({
  mixturesOfSubstance: mixtureSubstancesBySubstance(state),
  needsScenarioOf: needsScenarioByShipment(state),
  shipmentsOfSubstance: shipmentsBySubstance(state),
  suppliersById: state.suppliers.models
});

export default connect(mapStateToProps)(Component);
